import Editor from "@/components/editor/Editor.vue";
import ViewDigitalSignage from "@/views/digital-signage/view-digital-signage/viewDigitalSignage.vue";
import PublishDigitalSignageDlg from "@/views/digital-signage/publish-digital-signage/PublishDigitalSignage.vue";
import WingsDigitalSignage from "@/views/digital-signage/wings-digital-signage/WingsDigitalSignage.vue";
import { ValidationRules } from "@/utils/validation-rules";
import firebase from "firebase/app";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { DigitalSignagesTypes } from "@/enums/DigitalSignagesTypes";
import { ContentStatus } from "@/enums/ContentStatus";
import { ContentTypes } from "@/enums/ContentTypes";
import moment from "moment/moment";
import { StaffAccessLevels } from "@/enums/StaffAccessLevels";
import { getRegionName } from "@/utils/functionsRegion";
import { RequestCode } from "@/enums/RequestCode";
import { OrientationTypes } from "@/enums/OrientationTypes";
import { DigitalSignageDateOptions } from "@/enums/DigitalSignageDateOptions";
import { DigitalSignageEndDateOptions } from "@/enums/DigitalSignageEndDateOptions";
import { Week } from "@/consts/Week";
import TimeRangeDropdown from "@/components/pickers/TimeRangeDropdown.vue";
import {ContentCreatorTypes} from "@/enums/ContentCreatorTypes";
import {icon} from "@fortawesome/fontawesome-svg-core";
import {PrintableCalendarFonts} from "@/consts/PrintableCalendarFonts";
import AccessControlMixin from "@/mixins/AccessControlMixin";
import draggable from 'vuedraggable';
import { EventsTypes } from '@/enums/EventsTypes';
import { serializer } from '@/api/shared/serializer';
import ConfirmDlg from "@/components/popup/confirm-dialog/ConfirmDlg.vue";

export default {
    name: "DigitalSignage",
    mixins: [AccessControlMixin],
    components: {
        Editor,
        ViewDigitalSignage,
        ValidationObserver,
        ValidationProvider,
        PublishDigitalSignageDlg,
        WingsDigitalSignage,
        TimeRangeDropdown,
        draggable,
        ConfirmDlg
    },
    data() {
        return {
            isUrlInvalid: false,
            customContent: [],
            currentStep: 1,
            currentOpen: true,
            loading: {
                save: false,
                updateChannels: false,
                delete: false,
                createContent: false
            },
            isEdit: true,
            settings: {
                isShowSidebar: this.digitalSignage?.isShowSidebar ?? true,
                backgroundSidebar: this.digitalSignage?.backgroundSidebar ?? '#3f51b5',
                isShowScreensaver: this.digitalSignage?.isShowScreensaver ?? false,
                backgroundScreensaver: this.digitalSignage?.backgroundScreensaver ?? '#ffffff',
                fontFamilyScreensaver: this.digitalSignage?.fontFamilyScreensaver ?? 'Roboto'
            },
            dialog: false,
            urlErrorMsg: '',
            minDate: moment(new Date()).format("YYYY-MM-DD"),
            staffAccessLevels: StaffAccessLevels,
            mode: 'hexa',
            isReadyForChange: false,
            alert: true,
            eventImagesPages: 0,
            selectedWings: []
        };
    },
    computed: {
        dsTypes() {
            return Object.values(DigitalSignagesTypes)
        },
        digitalSignageTypes() {
            return DigitalSignagesTypes;
        },
        rules() {
            return {
                rotationTime: [
                    ValidationRules.positiveNumber
                ]
            }
        },
        digitalSignage() {
            return this.$store.state.digitalSignageModule.currentDigitalSignage;
        },
        currentFacility() {
            return this.$store.state.authModule.currentFacility;
        },
        currentUser() {
            return this.$store.state.authModule.user;
        },
        contentCreatorList() {
            return this.$store.state.contentCreatorModule.content.filter((x) => {
                if (x.status === ContentStatus.Published && x.type === ContentTypes.DigitalSignagePage) {
                    return x;
                }
            })
        },
        DigitalSignageDateOptions() {
            return DigitalSignageDateOptions;
        },
        digitalSignageDateOptions() {
            return Object.values(this.DigitalSignageDateOptions);
        },
        digitalSignageEndDateOptions() {
            return DigitalSignageEndDateOptions
        },
        weekDays() {
            return Week;
        },
        fontsFamily() {
            return [
                'Roboto',
                ...Object.values(PrintableCalendarFonts),
            ];
        },
        dragOptions() {
            return {
                animation: 200,
                group: "description",
                disabled: false,
                ghostClass: "ghost"
            };
        }
    },
    async created() {
        await this.$store.dispatch("getDigitalSignage", this.$route.params.id);
        await this.$store.dispatch("getCreatorContent");
        await this.getEventsWithPictures();
        await this.setStyles();
        this.isReadyForChange = true;
    },
   
    methods: {
        toggleStep(choosenStep) {
            if (choosenStep !== this.currentStep){
                this.currentOpen = true;
            }
            else{
                this.currentOpen = !this.currentOpen;
            }
            this.currentStep = choosenStep;
        },
        updateContent(page) {
            this.$store.dispatch("saveDigitalSignage", this.digitalSignage);
        },
        async addPage() {

            const updatedDs = JSON.parse(JSON.stringify(this.digitalSignage));

            const page: any = {
                type: this.digitalSignageTypes.ContentCreator,
                contentCreatorId: this.contentCreatorList[0].id,
                name: "",
                enabled: true,
                timeInSeconds: 10,
                url: "",
                displayDate: false,
                displayOn: this.DigitalSignageDateOptions.AllTheTime,
                displayForDays: [],
                startDate: moment(new Date()).format("YYYY-MM-DD"),
                time: {
                    start: moment("09:00", "HH:mm").format(this.$store.state.facilityModule.selectedFacility.timeFormat),
                    end: moment("17:00", "HH:mm").format(this.$store.state.facilityModule.selectedFacility.timeFormat)
                }
            }

            if(updatedDs.pages?.length >=1) {
                page.order = updatedDs.pages.length + 1
                updatedDs.pages.splice(this.currentStep, 0, page)
                this.currentStep += 1;
            }
            else {
                page.order = 1
                updatedDs.pages = [page]
                this.currentStep = 1
            }

            this.digitalSignage.pages = updatedDs.pages.map((x, index) => {
                return {
                    ...x,
                    order: index + 1
                }
            });

            //await this.$store.dispatch("saveDigitalSignage", updatedDs);
        },
        removePage(place) {
            const updatedDs = this.digitalSignage;
            this.digitalSignage.pages = updatedDs.pages.reduce((acc, x) => {
                if (x.order !== place) {
                    acc.push({
                        ...x,
                        order: acc.length + 1
                    });
                }
                return acc;
            }, []);

            /*updatedDs.pages.splice(place - 1, 1);
            this.$store.dispatch("saveDigitalSignage", this.digital-signage);*/
        },
        onAddVideoUrl(url, pageType) {
            if (pageType == 'File Upload' && url) {
                const _url = url.toLowerCase()
                if (_url.includes('youtube')) {
                    this.setUrlErrorMsg(this.$i18n.messages[this.$i18n.locale]['EditDigitalSignage.InvalidLinkUseYouTubeLinkMessage'])
                }
                else if (!/\.(doc|docx|pdf|png|jpg|jpeg)(\?+.+)?$/.test(_url)) {
                    this.setUrlErrorMsg(this.$i18n.messages[this.$i18n.locale]['EditDigitalSignage.InvalidLinkUseFileLinkMessage']);
                }
                else {
                    this.resetUrlErrorMsg()
                }
            }
        },
        setUrlErrorMsg(message) {
            this.isUrlInvalid = true
            this.urlErrorMsg = message
        },
        resetUrlErrorMsg() {
            this.isUrlInvalid = false
            this.urlErrorMsg = ''
        },
        async saveChanges() {
            this.loading.save = true;
            this.digitalSignage.id = this.$route.params.id;

            if (!this.validContentPages()) {
                return;
            }

            await this.$store.dispatch("saveDigitalSignage", this.digitalSignage);

            if (this.digitalSignage?.publishTo && this.digitalSignage?.publishTo.length) {
                await this.saveForPublishFacilities();
            }

            this.$forceUpdate();
            this.loading.save = false;
        },
        validContentPages() {
            let isValid = true;
            this.digitalSignage.pages.forEach((page) => {
                if(page.type === this.digitalSignageTypes.ContentCreator && !page.contentCreatorId) {
                    this.loading.save = false;
                    this.$toast.open({
                        type: "error",
                        message: `Select content for the "${page.name}" page please`
                    });
                    isValid = false;
                }
            });
            return isValid;
        },
        typeChange(page) {
            this.isUrlInvalid = false;
            page.url = '';
            if (page.type === this.digitalSignageTypes.EventImages && this.eventImagesPages !== 0){
                page.timeInSeconds = this.eventImagesPages * 5;
                page.rotationTime = this.eventImagesPages * 5;
            }
        },
        saveDisabled() {
            this.$store.dispatch("saveDigitalSignage", this.digitalSignage);
        },
        async deleteDs() {
            this.$refs.ConfirmDlg.open(
              null,
              this.$t("EditDigitalSignage.DeleteChannelQuestion"),
              false
            ).then(async response => {
                if (response && response.agree) {
                    this.loading.delete = true;
                    await this.$store.dispatch("deleteDigitalSignage", this.$route.params.id)
                      .then(() => {
                          this.loading.delete = false;
                          this.$toast.open({
                              message: this.$t("EditDigitalSignage.DeleteChannelSuccess"),
                              type: "success"
                          });
                      }).catch((error) => {
                          this.$toast.open({
                              message: `${error.message}`,
                              type: "error"
                          });
                      })
                }
            })
        },
        async saveForPublishFacilities() {
            const response = await firebase.app().functions(getRegionName()).httpsCallable('utils-getOrgDocuments')({
                orgId: this.$store.state.authModule.currentFacilityData.orgId,
                collectionName: 'digitalSignage',
                conditions: [{
                    property: 'parentDigitalSignageId',
                    condition: '==',
                    value: this.digitalSignage.parentDigitalSignageId
                }]
            });

            const digitalSignageByFacility = response.data.data
                .filter(x => x.facilityId !== this.$store.state.authModule.currentFacility)
                .filter(x => x.parentDigitalSignageId === this.digitalSignage.parentDigitalSignageId);

            if (response.data.code === RequestCode.Success && digitalSignageByFacility.length) {

                for (let i = 0; i < digitalSignageByFacility.length; i++) {
                    const doc = digitalSignageByFacility[i];

                    await firebase.app().functions(getRegionName()).httpsCallable('utils-updateOrgDocument')({
                        orgId: this.$store.state.authModule.currentFacilityData.orgId,
                        collectionName: 'digitalSignage',
                        docId: doc.id,
                        facilityId: doc.facilityId,
                        updates: {
                            isFamilyChannel: this.digitalSignage.isFamilyChannel,
                            isResidentChannel: this.digitalSignage.isResidentChannel,
                            pages: this.digitalSignage.pages,
                        }
                    });
                }
            }
        },
        async openPreview() {
            if (!this.validContentPages()) {
                return;
            }

            const route = this.$router.resolve({
                path:
                    "/digital-signage/" +
                    this.currentFacility +
                    "/v/" +
                    this.$route.params.id
            });
            window.open(route.href, "_blank");
        },
        async updateChannels() {
            this.loading.updateChannels = true;
            await firebase
                .firestore()
                .collection("digitalSignage")
                .doc(this.$route.params.id)
                .update({
                    "isResidentChannel": this.digitalSignage?.isResidentChannel,
                    "isFamilyChannel": this.digitalSignage?.isFamilyChannel
                })
            this.loading.updateChannels = false;
        },
        openSettings() {
            this.dialog = true;
        },
        closeSettings() {
            this.dialog = false;
        },
        setStyles() {
            this.settings.isShowSidebar = this.digitalSignage?.isShowSidebar ?? true;
            this.settings.backgroundSidebar = this.digitalSignage?.backgroundSidebar ?? '#3f51b5';
            this.settings.isShowScreensaver = this.digitalSignage?.isShowScreensaver ?? true;
            this.settings.backgroundScreensaver = this.digitalSignage?.backgroundScreensaver ?? '#ffffff';
            this.settings.fontFamilyScreensaver = this.digitalSignage?.fontFamilyScreensaver ?? 'Roboto';
        },
        async updateSettings() {
            this.loading.update = true;
            this.digitalSignage.isShowSidebar = this.settings.isShowSidebar;
            this.digitalSignage.backgroundSidebar = this.settings.backgroundSidebar;
            this.digitalSignage.isShowScreensaver = this.settings.isShowScreensaver;
            this.digitalSignage.backgroundScreensaver = this.settings.backgroundScreensaver;
            this.digitalSignage.fontFamilyScreensaver = this.settings.fontFamilyScreensaver;
            await this.$store.dispatch("saveDigitalSignage", this.digitalSignage);
            await this.$store.dispatch("getDigitalSignage", this.$route.params.id);
            this.loading.update = false;
            this.closeSettings();
        },
        selectContentPage(page, item) {
            page.contentCreatorId = item.id;
            this.$forceUpdate();
        },
        openContentCreatorPage(row) {
            window.open(`/content-list/${row.id.toString()}`, '_blank');
        },
        createNewContent() {
            this.loading.createContent = true;
            const defaultContent = '<div class="is-section is-box is-section-100 type-poppins box-autofit"><div class="is-overlay"></div><div class="is-boxes"><div class="is-box-centered is-opacity-95"><div class="is-container v2 is-content-700 leading-14 size-18"></div></div></div></div>';

            const content = {
                facilityId: this.$store.state.authModule.currentFacility,
                name: "New content",
                type: ContentTypes.DigitalSignagePage,
                contentCreatorType: ContentCreatorTypes.Templates,
                status: ContentStatus.Draft,
                createdBy: this.$store.state.authModule.user.name,
                datePublished: '',
                html: defaultContent,
                mainCss: '',
                sectionCss: '',
                orientation: OrientationTypes.Landscape,
            }

            this.$store.dispatch("addCreatorContent", content).then(async contentId => {
                await this.$store.dispatch("getCreatorContent");

                this.$toast.open({
                    message: `Content successfully added`,
                    type: "success"
                });

                setTimeout(() => {
                    this.$router.push({ path: `/content-list/${contentId}` });
                }, 500)
            }).catch((error) => {
                this.$toast.open({
                    message: `${error.message}`,
                    type: "error"
                });
            }).finally(() => {
                this.loading.createContent = false;
            })
        },
        onTimeRangeChange(timeRange, page) {
            page.time.start = timeRange.startTime
            page.time.end = timeRange.endTime
        },
        startDayIn(page) {
            const { startDate, displayDate } = page;

            if(!startDate) {
                return null;
            }

            const count = moment(startDate).diff(this.minDate, 'days');

            this.alert = (count === 0);

            return count;
        },
        isDisable(page) {
            if(this.startDayIn(page) > 0 && page.displayDate) {
                page.enabled = false;
                return true;
            }
        },
        startDayInTranslation(count) {
            return this.$t('EditDigitalSignage.StartDayIn')
              .replace('[count]', count)
              .replace('[days]', count === 1 ? 'day' : 'days');
        },
        async getEventsWithPictures() {
            const startDate = moment().subtract(3, 'week').toISOString().substring(0, 10);
            const endDate = moment().toISOString().substring(0, 10);
            const fromDate = moment(startDate).startOf('day').toDate()
            const toDate = moment(endDate).endOf("day").toDate()

            await firebase
              .firestore()
              .collection("calender")
              .where("facilityId", "==", this.currentFacility)
              .where("isPublished", "==", true)
              .where("start", ">=", fromDate)
              .where("start", "<=", toDate)
              .where("type", "in", [EventsTypes.ConciergeRequest, EventsTypes.Concierge, EventsTypes.PremiumServices, EventsTypes.LifestylePrograms])
              .get()
              .then((querySnapshot) => {
                  let events = serializer.querySnapshotToDocuments(querySnapshot);

                  events = events.filter((x: any) => {
                      if(x?.galleryPhotos && x?.galleryPhotos.length >= 1) {
                          return x;
                      }
                  })

                  if (this.selectedWings?.length) {
                      events = events.filter((x: any) => (x?.wingsIds && x?.wingsIds.length && x?.wingsIds.some(id => this.selectedWings.includes(id)) || (x?.wingsIds && !x?.wingsIds.length)))
                      events = events.sort((a: any, b: any) => moment(b.start.seconds * 1000).diff(moment(a.start.seconds * 1000)));
                  }
                  else {
                      events = []
                  }

                  this.countEventsPages(events)

              })
        },
        countEventsPages(events) {
            this.eventImagesPages = 0;

            events.slice(0, 4).forEach((event: any) => {
                this.eventImagesPages += Math.ceil(event.galleryPhotos.length / 6);
            });
        },
        handleWingsUpdate(newWings){
            this.selectedWings = newWings.find(x => x.facilityId === this.currentFacility).selectedWings;
            this.getEventsWithPictures();
        }
    }
};